<template>
  <div :class="checkNotApprovedRoute">
    <div :class="'flex flex-col items-center justify-center bg-white p-12'">
      <p :class="'text-lg font-bold my-4 text-xl text-center'">
        We're sorry! You did not qualify for a loan.
      </p>
      <p :class="'text-lg font-light my-4 text-center'">
        Based on the information you provided, we are unable to approve you for a loan at this time.
      </p>
      <img
        alt="img"
        :src="require('@/assets/img/sketches/rejection_image.svg')"
        class="md:w-1/5 my-4"
      />
      <p :class="'my-4 text-center text-lg'">
        You may explore external sites to find a loan offer that works for you.
      </p>
      <button
        @click="updateTimestampAndRouteToQuinstreet()"
        class="w-310 btn base-button btn-primary p-2 rounded my-4"
      >
        Explore Other Loan Options
      </button>
      <!-- <a
        :href="getExternalLoanLink"
        target="_blank"
        class="w-310 btn base-button btn-primary p-2 rounded my-4"
      >
        Explore Other Loan Options
      </a> -->
      <!-- <router-link
        :to="getExternalLoanLink"
        class="w-310 btn base-button btn-primary p-2 rounded my-4"
        >Explore Other Loan Options</router-link
      > -->
      <router-link to="/" class="w-310 btn base-button btn-primary-two p-2 rounded my-4"
        >Return to Homepage</router-link
      >
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
export default {
  name: 'not-approved',
  computed: {
    checkNotApprovedRoute() {
      if (window.location.href.includes('not-approved')) {
        return 'pt-16 md:p-32'
      }
      return ''
    }
  },
  methods: {
    updateTimestampAndRouteToQuinstreet() {
      this.loading = true
      this.$apiClient
        .mutate({
          mutation: gql(
            `mutation { addQuinstreetTimestamp(username: "${this.$store.getters.username}") }`
          )
        })
        .then(({ data }) => {
          console.log(data)
        })
        .catch((e) => {
          console.log(e)
          console.log(`FE Error in updateQuinstreetTimestamp: ${e}`)
        })
        .finally(() => {
          this.loading = false
          const link = this.getExternalLoanLink()
          window.location.href = link
        })
    },
    getExternalLoanLink() {
      /**
       * This is a computed because in the future we might add
       * specific params to customize the loan links for users
       */
      return 'http://o1.qnsr.com/cgi/r?;n=203;c=1681890;s=32978;x=7936;f=202301031132330;u=j;z=TIMESTAMP;AFFID=notApproved'
    }
  }
}
</script>
